import { createFileRoute } from "@tanstack/react-router";
import { createElement, useEffect, useMemo, useRef } from "react";

const StripePage = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const clientSecret = useMemo(() => {
    const url = new URL(globalThis.location.href);
    return url.searchParams.get("clientSecret") || "";
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.head.appendChild(script);

    return (): void => {
      script.remove();
    };
  }, []);

  useEffect(() => {
    const tableId = import.meta.env.VITE_STRIPE_TABLE_ID;
    const publishableKey = import.meta.env.VITE_STRIPE_KEY;
    const container = containerRef.current;

    if (!container) return;

    if (!tableId || !publishableKey || !clientSecret) {
      container.innerHTML =
        '<div style="padding:12px;border:1px solid #fca5a5;background:#fef2f2;color:#991b1b;border-radius:8px;">Missing Stripe configuration or clientSecret.</div>';
      return;
    }

    container.innerHTML = `
      <stripe-pricing-table
        pricing-table-id="${tableId}"
        publishable-key="${publishableKey}"
        customer-session-client-secret="${clientSecret}"
      ></stripe-pricing-table>
    `;
  }, [clientSecret]);

  return createElement(
    "div",
    { className: "min-h-screen w-full bg-background p-4 md:p-8" },
    createElement(
      "div",
      { className: "mx-auto max-w-4xl" },
      createElement(
        "h1",
        { className: "mb-4 text-xl font-semibold" },
        "ROSC Subscription"
      ),
      createElement("div", { ref: containerRef })
    )
  );
};

export const Route = createFileRoute("/stripe")({
  component: StripePage,
});
